const accessUsers = {

    PROFILE: {
        path: '/profile'
    },


    CUSTOMER_LIST: {
        path: '/customer-list'
    },

    CUSTOMER_DETAILS: {
        path: '/customer-details'
    },

    ADD_CUSTOMER: {
        path: '/create-customer'
    },

    UPDATE_CUSTOMER: {
        path: '/edit-customer'
    },

    UPDATE_CUSTOMER_PASSWORD: {
        path: '/update-customer-password'
    },


    MEMBER_LIST: {
        path: '/member-list'
    },

    ADD_MEMBER: {
        path: '/create-member'
    },

    UPDATE_MEMBER: {
        path: '/edit-member'
    },


    AGRONOMY_LIST: {
        path: '/agronomist-list'
    },

    ADD_AGRONOMY: {
        path: '/create-agronomist'
    },

    UPDATE_AGRONOMY: {
        path: '/edit-agronomist'
    },


    SUPERVISOR_LIST: {
        path: '/supervisor'
    },

    ADD_SUPERVISOR: {
        path: '/add-supervisor'
    },

    UPDATE_SUPERVISOR: {
        path: '/update-supervisor'
    },

    DELETE_SUPERVISOR: {
        path: '/delete-supervisor'
    },


    STAFF_LIST: {
        path: '/staff-list'
    },

    ADD_STAFF: {
        path: '/add-staff'
    },

    UPDATE_STAFF: {
        path: '/edit-staff'
    },

    DELETE_STAFF: {
        path: '/delete-staff'
    },

}

export default accessUsers;